import { type BoxProps, Column, Txt } from '@stenajs-webui/core';
import { cssColor } from '@stenajs-webui/theme';
import type { FC, ReactNode } from 'react';

export interface ValidationWrapperProps {
  gap?: BoxProps['gap'];
  renderField: (isValid: boolean) => ReactNode;
  style?: BoxProps['style'];
  validationError: string | null | undefined;
}

export const ValidationWrapper: FC<ValidationWrapperProps> = ({
  renderField,
  validationError,
  gap = 0.5,
  style,
}) => (
  <Column gap={gap} style={style} flex={1}>
    {renderField(validationError == null)}
    {validationError && (
      <Txt key={validationError} size={'small'} color={cssColor('--lhds-color-red-500')}>
        {validationError}
      </Txt>
    )}
  </Column>
);
